// Wire format and error codes of the privacy notice surface (EW-74).
// Consumers: the control plane controllers (producers), the admin FE
// Compliance page. (The desktop fork does not import this file; it reaches
// the me contract through its local echo-me-contract shim.)
export const PRIVACY_NOTICE_MAX_PDF_MB = 50;
export const PRIVACY_NOTICE_MAX_PDF_BYTES = PRIVACY_NOTICE_MAX_PDF_MB * 1024 * 1024;
//# sourceMappingURL=privacy-notice.js.map